import { createReducer } from '@reduxjs/toolkit';

import { resetLogsFilter, setLogsFilter } from '../../actions/logs/logsFilter';

const initialState = {
  page: 1,
  size: 30,
  action: undefined,
  type: undefined,
  user: undefined,
  from: undefined,
  to: undefined,
};

const logsFilterReducer = createReducer(initialState, {
  [setLogsFilter]: (state, { payload }) => ({
    ...state,
    ...payload
  }),
  [resetLogsFilter]: () => initialState
});

export default logsFilterReducer;
